// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type GetUserGoogleCalendarApiAuthenticatedQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type GetUserGoogleCalendarApiAuthenticatedQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'UserModelSelf' }
    & Pick<PrivateSchemaTypes.UserModelSelf, 'id' | 'isGoogleCalendarAPIAuthenticated'>
  ) }
);

export type GetGoogleCalendarAuthSettingsQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type GetGoogleCalendarAuthSettingsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & Pick<PrivateSchemaTypes.AdminViewerQueries, 'getGoogleCalendarAuthSettings'>
  )> }
);

export type SetCredentialsForGoogleCalendarApiMutationVariables = PrivateSchemaTypes.Exact<{
  authCode: PrivateSchemaTypes.Scalars['String'];
}>;


export type SetCredentialsForGoogleCalendarApiMutation = (
  { __typename?: 'Mutation' }
  & { me: (
    { __typename?: 'UserModelSelfMutation' }
    & Pick<PrivateSchemaTypes.UserModelSelfMutation, 'setCredentialsForGoogleCalendarApi'>
  ) }
);

export type RevokeCredentialsForGoogleCalendarApiMutationVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type RevokeCredentialsForGoogleCalendarApiMutation = (
  { __typename?: 'Mutation' }
  & { me: (
    { __typename?: 'UserModelSelfMutation' }
    & Pick<PrivateSchemaTypes.UserModelSelfMutation, 'revokeCredentialsForGoogleCalendarApi'>
  ) }
);


export const GetUserGoogleCalendarApiAuthenticatedDocument = gql`
    query getUserGoogleCalendarApiAuthenticated {
  me {
    id
    isGoogleCalendarAPIAuthenticated
  }
}
    `;

/**
 * __useGetUserGoogleCalendarApiAuthenticatedQuery__
 *
 * To run a query within a React component, call `useGetUserGoogleCalendarApiAuthenticatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserGoogleCalendarApiAuthenticatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserGoogleCalendarApiAuthenticatedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserGoogleCalendarApiAuthenticatedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserGoogleCalendarApiAuthenticatedQuery, GetUserGoogleCalendarApiAuthenticatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserGoogleCalendarApiAuthenticatedQuery, GetUserGoogleCalendarApiAuthenticatedQueryVariables>(GetUserGoogleCalendarApiAuthenticatedDocument, options);
      }
export function useGetUserGoogleCalendarApiAuthenticatedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserGoogleCalendarApiAuthenticatedQuery, GetUserGoogleCalendarApiAuthenticatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserGoogleCalendarApiAuthenticatedQuery, GetUserGoogleCalendarApiAuthenticatedQueryVariables>(GetUserGoogleCalendarApiAuthenticatedDocument, options);
        }
export type GetUserGoogleCalendarApiAuthenticatedQueryHookResult = ReturnType<typeof useGetUserGoogleCalendarApiAuthenticatedQuery>;
export type GetUserGoogleCalendarApiAuthenticatedLazyQueryHookResult = ReturnType<typeof useGetUserGoogleCalendarApiAuthenticatedLazyQuery>;
export type GetUserGoogleCalendarApiAuthenticatedQueryResult = Apollo.QueryResult<GetUserGoogleCalendarApiAuthenticatedQuery, GetUserGoogleCalendarApiAuthenticatedQueryVariables>;
export const GetGoogleCalendarAuthSettingsDocument = gql`
    query getGoogleCalendarAuthSettings {
  admin {
    getGoogleCalendarAuthSettings
  }
}
    `;

/**
 * __useGetGoogleCalendarAuthSettingsQuery__
 *
 * To run a query within a React component, call `useGetGoogleCalendarAuthSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleCalendarAuthSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoogleCalendarAuthSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleCalendarAuthSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGoogleCalendarAuthSettingsQuery, GetGoogleCalendarAuthSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGoogleCalendarAuthSettingsQuery, GetGoogleCalendarAuthSettingsQueryVariables>(GetGoogleCalendarAuthSettingsDocument, options);
      }
export function useGetGoogleCalendarAuthSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGoogleCalendarAuthSettingsQuery, GetGoogleCalendarAuthSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGoogleCalendarAuthSettingsQuery, GetGoogleCalendarAuthSettingsQueryVariables>(GetGoogleCalendarAuthSettingsDocument, options);
        }
export type GetGoogleCalendarAuthSettingsQueryHookResult = ReturnType<typeof useGetGoogleCalendarAuthSettingsQuery>;
export type GetGoogleCalendarAuthSettingsLazyQueryHookResult = ReturnType<typeof useGetGoogleCalendarAuthSettingsLazyQuery>;
export type GetGoogleCalendarAuthSettingsQueryResult = Apollo.QueryResult<GetGoogleCalendarAuthSettingsQuery, GetGoogleCalendarAuthSettingsQueryVariables>;
export const SetCredentialsForGoogleCalendarApiDocument = gql`
    mutation setCredentialsForGoogleCalendarApi($authCode: String!) {
  me {
    setCredentialsForGoogleCalendarApi(authCode: $authCode)
  }
}
    `;
export type SetCredentialsForGoogleCalendarApiMutationFn = Apollo.MutationFunction<SetCredentialsForGoogleCalendarApiMutation, SetCredentialsForGoogleCalendarApiMutationVariables>;

/**
 * __useSetCredentialsForGoogleCalendarApiMutation__
 *
 * To run a mutation, you first call `useSetCredentialsForGoogleCalendarApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCredentialsForGoogleCalendarApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCredentialsForGoogleCalendarApiMutation, { data, loading, error }] = useSetCredentialsForGoogleCalendarApiMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *   },
 * });
 */
export function useSetCredentialsForGoogleCalendarApiMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCredentialsForGoogleCalendarApiMutation, SetCredentialsForGoogleCalendarApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCredentialsForGoogleCalendarApiMutation, SetCredentialsForGoogleCalendarApiMutationVariables>(SetCredentialsForGoogleCalendarApiDocument, options);
      }
export type SetCredentialsForGoogleCalendarApiMutationHookResult = ReturnType<typeof useSetCredentialsForGoogleCalendarApiMutation>;
export type SetCredentialsForGoogleCalendarApiMutationResult = Apollo.MutationResult<SetCredentialsForGoogleCalendarApiMutation>;
export type SetCredentialsForGoogleCalendarApiMutationOptions = Apollo.BaseMutationOptions<SetCredentialsForGoogleCalendarApiMutation, SetCredentialsForGoogleCalendarApiMutationVariables>;
export const RevokeCredentialsForGoogleCalendarApiDocument = gql`
    mutation revokeCredentialsForGoogleCalendarApi {
  me {
    revokeCredentialsForGoogleCalendarApi
  }
}
    `;
export type RevokeCredentialsForGoogleCalendarApiMutationFn = Apollo.MutationFunction<RevokeCredentialsForGoogleCalendarApiMutation, RevokeCredentialsForGoogleCalendarApiMutationVariables>;

/**
 * __useRevokeCredentialsForGoogleCalendarApiMutation__
 *
 * To run a mutation, you first call `useRevokeCredentialsForGoogleCalendarApiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCredentialsForGoogleCalendarApiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCredentialsForGoogleCalendarApiMutation, { data, loading, error }] = useRevokeCredentialsForGoogleCalendarApiMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeCredentialsForGoogleCalendarApiMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokeCredentialsForGoogleCalendarApiMutation, RevokeCredentialsForGoogleCalendarApiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeCredentialsForGoogleCalendarApiMutation, RevokeCredentialsForGoogleCalendarApiMutationVariables>(RevokeCredentialsForGoogleCalendarApiDocument, options);
      }
export type RevokeCredentialsForGoogleCalendarApiMutationHookResult = ReturnType<typeof useRevokeCredentialsForGoogleCalendarApiMutation>;
export type RevokeCredentialsForGoogleCalendarApiMutationResult = Apollo.MutationResult<RevokeCredentialsForGoogleCalendarApiMutation>;
export type RevokeCredentialsForGoogleCalendarApiMutationOptions = Apollo.BaseMutationOptions<RevokeCredentialsForGoogleCalendarApiMutation, RevokeCredentialsForGoogleCalendarApiMutationVariables>;